import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { Label } from '../common/Styles';
import useOnClickOutside from '../../../../hooks/useOnClickOutside';

const Wrapper = styled.div`
  margin-right: 15px;
  border: 1px solid black;
  border-bottom: ${({ open }) => (open ? 'none' : '1px solid black')};
  min-width: 210px;
  width: 210px;
  height: 45px;
  position: relative;

  .title-container {
    padding: 10px 20px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
  }

  .options-container {
    width: 210px;
    left: -1px;
    background: white;
    position: absolute;
    z-index: 10;
    padding: 15px 20px;
    border-bottom: 1px solid black;
    border-right: 1px solid black;
    border-left: 1px solid black;
    top: 33px;

    .total-fabrics {
      display: inline;
      opacity: 0.8;
    }
  }
`;

const Checkbox = ({ type = 'checkbox', name, checked = false, onChange }) => {
  return (
    <input type={type} name={name} checked={checked} onChange={onChange} />
  );
};

const Pattern = ({ patterns, patternIds, setPatternIds }) => {
  const [checkedItems, setCheckedItems] = useState({});
  const [open, setOpen] = useState(false);

  const ref = useRef(null);

  useOnClickOutside(ref, () => {
    if (open) {
      setOpen(false);
    }
  });

  const handleChange = (event, patternId) => {
    handleClick(patternId);
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: patternIds.some(id => id === parseInt(patternId))
    });
  };

  const handleClick = patternId => {
    const isSelected = patternIds.some(id => id === parseInt(patternId));
    if (isSelected) {
      setPatternIds(patternIds.filter(id => id !== parseInt(patternId)));
    } else {
      setPatternIds([...patternIds, parseInt(patternId)]);
    }
  };

  const checkboxes = patterns.map(pattern => {
    return { ...pattern, key: pattern.id, label: pattern.name };
  });

  return (
    <Wrapper open={open} ref={ref}>
      <div className="title-container" onClick={() => setOpen(!open)}>
        <Title color={patternIds.length ? `#2A5CAF` : 'black'}>
          Pattern {patternIds.length ? `(${patternIds.length})` : ''}
        </Title>

        {open ? (
          <img src="/assets/pdp/arrow-up.svg" alt="close filter" />
        ) : (
          <img src="/assets/pdp/arrow-down.svg" alt="open filter" />
        )}
      </div>

      {open && (
        <div className="options-container">
          {checkboxes.map(item => (
            <Label key={item.key}>
              {item.name}{' '}
              <div className="total-fabrics">({item.total_fabrics})</div>
              <Checkbox
                name={item.name}
                checked={patternIds.some(id => id === parseInt(item.id))}
                onChange={event => handleChange(event, item.id)}
              />
              <span className="checkmark" />
            </Label>
          ))}{' '}
        </div>
      )}
    </Wrapper>
  );
};

export default Pattern;

const Title = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: ${({ theme }) => theme.old ? 'bold' : 600};
  font-size: 13px;
  line-height: 23px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${({ color }) => color};
`;
